import { Button, Form, Row, Space } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubsidiaries } from '../../../../appRedux/actions';
import { getStockByBranch } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';

export const StockByBranchFilters = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    dispatch(getStockByBranch(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ minWidth: '200px' }}
              options={subsidiaries?.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            ></CustomSelect>
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
